import { useDimensionEntry } from "../lib/dimensionDefs.js";

// Resolves an endpoint UUID to its catalog hostname. Falls back to a short id
// while the dimension hydrates, so a row never renders a bare UUID.
export function EndpointName({ id, fallback = "unattributed", unresolvedFallback }) {
    const { label } = useDimensionEntry(id ? "endpoints" : null, id ?? null);
    if (!id) return <>{fallback}</>;
    return <>{label && label !== String(id) ? label : unresolvedFallback ?? `endpoint ${String(id).slice(0, 8)}`}</>;
}
